<template>
<div class="goods-detail-item" v-if="comboGoodsVoList && comboGoodsVoList.length ">
    <div class="blend-options" @click="bindGoCombo()">
        <a href="javascript:;">
            <div class="blend-title">
                <span class="blend-title-left" data-name="推荐组合">Bought Together</span>
                <span class="blend-title-right">
                  <!--共<em>{{comboGoodsVoList.length}}</em>款-->
                  <i></i></span>

            </div>
            <div class="blend-content">
                <ul>
                    <li class="blend-item" v-for="(item , index) in currentComboGoodList" >
                        <div class="goods-thumb"><img :src="item.imageSrc"></div>
                        <div class="blend-add" v-if="index != currentComboGoodList.length-1 "></div>
                    </li>
                </ul>
            </div>
        </a>
    </div>
</div>
</template>
<script>
    export default {
        props: {
            comboGoodsVoList: {
                type: Array,
                required: false
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {

            }
        },
        /**
         * 计算属性
         */
        computed: {
            //第一个推荐组合的商品列表
            currentComboGoodList: function() {
                var result = [],
                    first = [],
                    _comboGoodsVoList = this.comboGoodsVoList;
                if (_comboGoodsVoList.length) {
                    if (_comboGoodsVoList[0].goodsVoList && _comboGoodsVoList[0].goodsVoList.length) {
                        _comboGoodsVoList.forEach(function(value){
                            result =  result.concat(value.goodsVoList)
                        })
                        result = result.slice(0,4)
                    }
                }
                return result;
            }
        },
        /**
         * 自定义方法
         */
        methods: {
            //点击查看推荐组合
            bindGoCombo:function(){
              ga('send', 'event', '选择推荐组合按钮', '点击', '按钮点击'); //谷歌锚点
                this.$emit('gocombo')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-combo/goods-combo.vue